
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'InferredArtifact',
  props: {
    vcsUrl: {
      type: String,
      required: true
    },
    number: {
      type: String,
      required: true
    }
  }
})
